import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";
import { INTER_OFFICE_STOCK_TRANSFER_API } from "../../Api";

const BASE_URL = process.env.REACT_APP_SERVER_URL;

const InterOfficeStockTransferFinishedGoodsApi = createApi({
  reducerPath: "InterOfficeStockTransferFinishedGoods",
  baseQuery,
  tagTypes: ["InterOfficeStockTransferFinishedGoods"],
  endpoints: (builder) => ({
    getInterOfficeStockTransferFinishedGoods: builder.query({
      query: ({ params, searchParams }) => {
        if (searchParams) {
          return {
            url: INTER_OFFICE_STOCK_TRANSFER_API + "/search/" + searchParams,
            method: "GET",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
            params
          };
        }
        return {
          url: INTER_OFFICE_STOCK_TRANSFER_API,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          params
        };
      },
      providesTags: ["InterOfficeStockTransferFinishedGoods"],
    }),
    getInterOfficeStockTransferFinishedGoodsById: builder.query({
      query: ({ id, params }) => {
        return {
          url: `${INTER_OFFICE_STOCK_TRANSFER_API}/${id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          params
        };
      },
      providesTags: ["InterOfficeStockTransferFinishedGoods"],
    }),
    addInterOfficeStockTransferFinishedGoods: builder.mutation({
      query: (payload) => ({
        url: INTER_OFFICE_STOCK_TRANSFER_API,
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["InterOfficeStockTransferFinishedGoods"],
    }),
    updateInterOfficeStockTransferFinishedGoods: builder.mutation({
      query: (payload) => {
        const { id, ...body } = payload;
        return {
          url: `${INTER_OFFICE_STOCK_TRANSFER_API}/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["InterOfficeStockTransferFinishedGoods"],
    }),
    deleteInterOfficeStockTransferFinishedGoods: builder.mutation({
      query: (id) => ({
        url: `${INTER_OFFICE_STOCK_TRANSFER_API}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["InterOfficeStockTransferFinishedGoods"],
    }),
  }),
});

export const {
  useGetInterOfficeStockTransferFinishedGoodsQuery,
  useGetInterOfficeStockTransferFinishedGoodsByIdQuery,
  useAddInterOfficeStockTransferFinishedGoodsMutation,
  useUpdateInterOfficeStockTransferFinishedGoodsMutation,
  useDeleteInterOfficeStockTransferFinishedGoodsMutation,
} = InterOfficeStockTransferFinishedGoodsApi;

export default InterOfficeStockTransferFinishedGoodsApi;
